var $ = require('jquery');
var Dropkick = require('dropkickjs')['default'];

module.exports = {
	init: function() {
		$('.dropkick select').each(function(){
			new Dropkick(this);
		});
	}
};
